import { RouteComponentProps } from "@reach/router";
import React from "react";
import { ErrorPage } from "../../ui/errors";

export const NotFoundPage = (props: RouteComponentProps) => {
	return <ErrorPage title='Oh no. Not found' />
}